module.exports = __webpack_public_path__ + "static/img/gazetaTopo1.9082686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/PMM-AL/gazetaTopo1.png
// module id = SPDK
// module chunks = 1